import React from "react"

const authContext = React.createContext({
    isAuthentication: false,
    token: "",
    login : ()=>{},
    logout : ()=>{},
});
export default authContext